export const iconFontAwesomeAstronomyGlobe = (
	<i className="fa-solid fa-globe"></i>
);
